var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{attrs:{"title":"最近10条错误报告","headers":_vm.headers,"items":_vm.items,"loading":_vm.list.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }